module.exports = __webpack_public_path__ + "static/media/user_profile.8e5ac0ea.jpg";